import { PureComponent } from 'react';
import autoBind from 'react-autobind';
import { Modal } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';

import withComponentName from '../../../../decorators/withComponentName';

import WistiaPlayer from '../../../Shared/WistiaPlayer';

import Styles from './styles.module.scss';

export class ModalWrapperComponent extends PureComponent {
  constructor(props, context) {
    super(props, context);
    autoBind(this);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    const { modal } = this.state;

    this.setState({
      modal: !modal,
    });
  }

  render() {
    const { source } = this.props;
    const { modal } = this.state;

    return (
      <>
        <div
          className={Styles.preview_image}
          onClick={this.toggle}
        />
        <Modal
          show={modal}
          dialogClassName={Styles.custom_modal}
          centered
          onHide={this.toggle}
        >
          <Modal.Header
            closeButton
          />
          <Modal.Body bsPrefix={Styles.modal_body}>
            <WistiaPlayer
              url={source}
              style={{
                margin: 'auto',
                width: '100%',
                height: '99%',
              }}
              controls
              config={{
                options: isMobile ? { playsinline: false } : {},
              }}
            />
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default withComponentName(ModalWrapperComponent);
